import React from 'react';
import { generateUniqueID } from 'web-vitals/dist/modules/lib/generateUniqueID';

import Animation from '../animation/animation';
import Grid from '../grid/grid';
import GridLine from '../grid-line/grid-line';

import ContactFormEn from '../contact-form/contact-form-en';
import ContactFormRu from '../contact-form/contact-form-ru';
import ContactFormCn from '../contact-form/contact-form-cn';

import SubCategory from '../subcategory/subcategory';
import ProjectsEn from '../../data/projects-en.json';
import ProjectsRu from '../../data/projects-ru.json';
import ProjectsCn from  '../../data/projects-cn.json';

import '../services/services.scss';
import './category.scss';
import educationHeader from '../../f/videos/education-header.mp4';
import educationHeaderCover from '../../f/img/education-header.webp';



const Category = ({ tag }) => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const eng = window.lang && window.lang === 'en';
  const cn = params.lang && (params.lang === 'cn');

  const projects = eng ? ProjectsEn : cn ? ProjectsCn : ProjectsRu;

  const {
    categoryName,
    title,
    description,
    subcategories,
    header,
    formTitle,
    formSubtitle,
    video,
    details,
  } = projects[tag];
  const subContainer = React.useRef();

  const initWorks = () => {
    const container = subContainer.current;

    if (!container) {
      return;
    }


    window.includeWorks.init();
  }

  const formParams = React.useMemo(() => {
    return {
      formId: tag,
      title: formTitle,
      subTitle: formSubtitle,
    }
  }, [tag, formTitle, formSubtitle]);

  React.useEffect(() => {
    initWorks();
  }, [])

  return (
    <React.Fragment>
      <div className="services services-category">
        <div className={`services-header services-header--${tag}`}>
          <h1 className="services-header__text" dangerouslySetInnerHTML={{__html: title}} />

          {tag !== 'education' && <Animation tag={tag} header={header}/>}
          {tag === 'education' && <video src={educationHeader} poster={educationHeaderCover} autoPlay muted loop />}

          <div className="als-text-container">
            <p className="services__text"
               dangerouslySetInnerHTML={{__html: description}}
            />
          </div>

          {details && (
              <div className="services__text" dangerouslySetInnerHTML={{__html: details}}></div>
          )}

          {video && (
            <Grid>
              <GridLine>
                <div className="services-container__video">
                  <div>
                    <iframe width="100%" height="auto" src={video} frameBorder="0" allowFullScreen="" />
                  </div>
                </div>
              </GridLine>
            </Grid>
            )}
        </div>

        <div ref={subContainer} className="subcategories">
          {
            Object.entries(subcategories).map(subcategory => {
              return (
                <SubCategory key={generateUniqueID()} {...subcategory[1]} categoryName={categoryName}/>
              )
            })
          }
        </div>

        {
          cn ? <ContactFormCn {...formParams}/> : (eng ? <ContactFormEn {...formParams}/> : <ContactFormRu {...formParams}/>)
        }

      </div>
    </React.Fragment>
  );
}

export default Category;
